export const baseUrl = "https://medisync-instance.onrender.com/api/v1/";
